import { render, staticRenderFns } from "./SurveyForm.vue?vue&type=template&id=0fa388aa&scoped=true"
import script from "./SurveyForm.vue?vue&type=script&lang=js"
export * from "./SurveyForm.vue?vue&type=script&lang=js"
import style0 from "./SurveyForm.vue?vue&type=style&index=0&id=0fa388aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa388aa",
  null
  
)

export default component.exports